<template>
  <v-app class="grey lighten-4" >
    <Navbar/>
     <v-main >
          <transition name="slide" mode="out-in" >
            <router-view></router-view>
          </transition>
         
    </v-main>
    <Footer/>
  </v-app>
</template>

<script>
import Navbar from './components/Navbar';
import Footer from './components/Footer';

export default {
  name: 'App',

  components: {
    Navbar, Footer,
  },

  data: () => ({
    //
    data: []
  }),
  created(){
    this.today()
  },
  methods: {
    today(){
      
    /*  this.data.push(moment("2020-01-01"))
      this.data.push(moment("2020-01-01 13:00"))
      this.data.push(moment())*/
    }
  }
  
};
</script>

<style >
  @keyframes slide-in{
    from {transform: translateX(-30px); opacity: 0;}
    to {transform: translateX(0px); opacity: 1;}
  }
   @keyframes slide-out{
    from {transform: translateX(0px); opacity: 1;}
    to {transform: translateX(-30px); opacity: 0;}
  }
  .slide-enter-active{
    animation: slide-in 0.3s ease;
  }
  .slide-leave-active{
    animation: slide-out 0.3s ease;
  }
</style>